import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0892dd31"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PretensionId" }
const _hoisted_2 = {
  key: 1,
  class: "PretensionId__content"
}
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col justify-center items-center mt-6"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-sm text-gray-400" }, "Загрузка претензии...", -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "content__header" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_9 = { class: "content__block" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "content__block__title" }, "Оcновная информация:", -1))
const _hoisted_11 = { class: "content__block__main" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Номер накладной заказчика:", -1))
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Количество товаров:", -1))
const _hoisted_16 = { key: 2 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Артикул:", -1))
const _hoisted_18 = { key: 3 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Наименование товара:", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Тип претензии:", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Номер объекта:", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Объект:", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Подразделение:", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Направление:", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Дата доставки:", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Название отправителя:", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Название получателя:", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Кто плательщик:", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Способ оплаты:", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "ФИО клиента:", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Телефон клиента:", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Описание товара:", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Компания:", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Сумма претензии:", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Суть запроса:", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Комментарий КК:", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Комментарий СБ:", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Сумма к возмещению:", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Виновная сторона:", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "ФИО виновной стороны:", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Дата согласования:", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Согласование:", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Email клиента:", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Виновная сторона:", -1))
const _hoisted_45 = {
  key: 0,
  class: "content__block"
}
const _hoisted_46 = {
  key: 1,
  class: "content__block"
}
const _hoisted_47 = {
  key: 2,
  class: "content__block"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_loader = _resolveComponent("loader")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_pretension_files = _resolveComponent("pretension-files")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_failed)
      ? (_openBlock(), _createBlock(_component_failed_fetch, {
          key: 0,
          loading: _ctx.state.is_loading,
          text: "При получении претензии произошла ошибка",
          onRefresh: _ctx.loadPretension
        }, null, 8, ["loading", "onRefresh"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_loader, { class: "primary" }),
                _hoisted_4
              ]))
            : (_ctx.state.pretension)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_page_title, {
                        title: `Претензия (ID: ${_ctx.state.pretension.id})`
                      }, null, 8, ["title"]),
                      _createVNode(_component_cheap, {
                        class: _normalizeClass(["small ml-5", {
                                primary: _ctx.state.pretension.status_id === 1,
                                yellow: [2, 3, 4, 7, 8, 9].includes(_ctx.state.pretension.status_id),
                                green: _ctx.state.pretension.status_id === 5,
                                red: _ctx.state.pretension.status_id === 6,
                            }])
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.state.pretension.status_name) + " " + _toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.state.pretension.status_changed_at)), 1)
                        ]),
                        _: 1
                      }, 8, ["class"])
                    ]),
                    _createVNode(_component_the_button, {
                      class: "second small text",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8,
                        _createTextVNode(" Назад ")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, [
                      (_ctx.state.pretension.dop_invoice_number)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                            _hoisted_13,
                            _createTextVNode(" " + _toDisplayString(_ctx.state.pretension.dop_invoice_number), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.pretension.product_quantity)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                            _hoisted_15,
                            _createTextVNode(" " + _toDisplayString(_ctx.state.pretension.product_quantity || '-'), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.pretension.article_number)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
                            _hoisted_17,
                            _createTextVNode(" " + _toDisplayString(_ctx.state.pretension.article_number || '-'), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.pretension.product_name)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                            _hoisted_19,
                            _createTextVNode(" " + _toDisplayString(_ctx.state.pretension.product_name || '-'), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("p", null, [
                        _hoisted_20,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.pretension.type_name || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_21,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.pretension.client_title || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_22,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.pretension.object || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_23,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.pretension.subdivision
                                    ? _ctx.state.pretension.subdivision.name
                                    : '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_24,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.pretension.direction || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_25,
                        _createTextVNode(" " + _toDisplayString(_ctx.formatDateFromBackend(_ctx.state.pretension.delivery_date) || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_26,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.pretension.sender_title || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_27,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.pretension.receiver_title || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_28,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.pretension.payment_type || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_29,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.pretension.payment_method || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_30,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.pretension.client_name || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_31,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.pretension.client_phone || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_32,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.pretension.product_description || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_33,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.pretension.company_name || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_34,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.pretension.product_amount || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_35,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.pretension.client_comment || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_36,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.pretension.quality_control_comment || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_37,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.pretension.security_service_comment || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_38,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.pretension.reimbursed_amount || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_39,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.pretension.culprit_title || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_40,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.pretension.culprit_name || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_41,
                        _createTextVNode(" " + _toDisplayString(_ctx.formatDateFromBackend(_ctx.state.pretension.agreement_date) || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_42,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.pretension.agreement_comment || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_43,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.pretension.client_email || '-'), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_44,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.pretension.guilty_side
                                    ? _ctx.state.pretension.guilty_side.name
                                    : '-'), 1)
                      ])
                    ])
                  ]),
                  (_ctx.getFiles('files').length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        _createVNode(_component_pretension_files, {
                          files: _ctx.getFiles('files'),
                          title: "Фото товара"
                        }, null, 8, ["files"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.getFiles('quality_control_file').length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                        _createVNode(_component_pretension_files, {
                          files: _ctx.getFiles('quality_control_file'),
                          title: "Заключительные файлы"
                        }, null, 8, ["files"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.getFiles('final_file').length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                        _createVNode(_component_pretension_files, {
                          files: _ctx.getFiles('final_file'),
                          title: "Заключительные файлы"
                        }, null, 8, ["files"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
        ]))
  ]))
}